import { render, staticRenderFns } from "./NavLinksModal.vue?vue&type=template&id=bffe4552&scoped=true"
import script from "./NavLinksModal.vue?vue&type=script&lang=js"
export * from "./NavLinksModal.vue?vue&type=script&lang=js"
import style0 from "./NavLinksModal.vue?vue&type=style&index=0&id=bffe4552&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffe4552",
  null
  
)

export default component.exports